/**
 * FallbackViewer — shown for types with no trustworthy client-side renderer
 * (doc, ppt, pptx, rtf) and as the terminal state when a preview fails.
 * Third-party embed viewers (Office/Google) would leak signed URLs to
 * external services, so these types are download-only by design.
 */
import React from 'react';
import { Center, VStack, Icon, Text, Button } from '@chakra-ui/react';
import { FiDownload } from 'react-icons/fi';
import { getFileKind, formatFileSize } from '../../../../constants/documentConstants';
import { getFileKindStyle } from '../fileKindStyles';

export default function FallbackViewer({ doc, onDownload, downloading = false }) {
  const style = getFileKindStyle(getFileKind(doc?.mimeType, doc?.fileName));
  return (
    <Center flex={1} px={6}>
      <VStack spacing={4} textAlign="center" maxW="sm">
        <Icon as={style.icon} boxSize={12} color={style.color} />
        <VStack spacing={1}>
          <Text fontWeight="medium" noOfLines={2}>
            {doc?.fileName}
          </Text>
          <Text fontSize="sm" color="gray.500">
            {formatFileSize(doc?.fileSize)}
          </Text>
        </VStack>
        <Text fontSize="sm" color="gray.500">
          No in-browser preview is available for this file type.
        </Text>
        {onDownload && (
          <Button
            size="sm"
            colorScheme="blue"
            leftIcon={<FiDownload />}
            onClick={onDownload}
            isLoading={downloading}
          >
            Download
          </Button>
        )}
      </VStack>
    </Center>
  );
}
